import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=556bd41d&lang=html&"
import script from "./TitleBlock.vue?vue&type=script&lang=js&"
export * from "./TitleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports